export const STUDENT_COLUMN = 'STUDENT_COLUMN';
export const STUDENT_INDEX = 'STUDENT_INDEX';
export const STUDENT_LOADING_INDEX = 'STUDENT_LOADING_INDEX';
export const STUDENT_LOADING_SHOW = 'STUDENT_LOADING_SHOW';
export const STUDENT_OPTION = 'STUDENT_OPTION';
export const STUDENT_RESET = 'STUDENT_RESET';
export const STUDENT_SEARCH = 'STUDENT_SEARCH';
export const STUDENT_SHOW = 'STUDENT_SHOW';
export const STUDENT_SCHOOL = 'STUDENT_SCHOOL';
